import { hideOverlay, showOverlay } from '../overlay/overlay';

// TODO: Should probably implement all of this as Promise
document.addEventListener('DOMContentLoaded', () => {
    // Enable all popup close buttons
    for (const closeButton of document.getElementsByClassName('close-button'))
    {
        closeButton.addEventListener('click', onClickCloseButton);
    }
});

function onClickCloseButton(event: MouseEvent)
{
    event.preventDefault();

    const target = event.currentTarget as HTMLElement;
    const popup = target.closest('.popup') as HTMLElement;

    if (popup)
    {
        hidePopup(popup);
    }
}

export function showPopup(popup: HTMLElement): void
{
    if (!popup.classList.contains('active'))
    {
        popup.classList.add('active');
        showOverlay();
    }
}

export function hidePopup(popup: HTMLElement): void
{
    if (popup.classList.contains('active'))
    {
        popup.classList.remove('active');
        hideOverlay();
    }
}

export function togglePopup(popup: HTMLElement): void
{
    if (popup.classList.contains('active'))
    {
        hidePopup(popup);
    } else
    {
        showPopup(popup);
    }
}
